module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border",
    staticStyle: {
      "background": "#d6d7d9"
    }
  }, [_c('div', {
    staticClass: "heading-cart"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 no-padding"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Activity Exposure Time")]), _vm._v(" "), (_vm.selectedBucketNameToImportConfig) ? _c('h3', {
    staticClass: "box-title text-danger animated flash config-notif"
  }, [_c('b', [_vm._v("Imported config from " + _vm._s(_vm.selectedBucketNameToImportConfig) + " Bucket. Click save to\n                                    use the config.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 no-padding"
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-lg-2",
    staticStyle: {
      "display": "inline-block",
      "padding": "0px",
      "margin": "0px"
    }
  }, [(!_vm.selectedBucketNameToImportConfig) ? _c('el-dropdown', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.selectBucketModule
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "title": 'Import Config'
    }
  }, [_vm._v("\n                                        Import Config"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), (_vm.bucketListForModuleConfig.length > 0) ? _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.bucketListForModuleConfig), function(bucket, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "command": index
      }
    }, [_vm._v(_vm._s(bucket.bucketName))])
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedBucketNameToImportConfig) ? _c('el-button', {
    staticStyle: {
      "min-width": "130px",
      "float": "right"
    },
    attrs: {
      "type": "danger",
      "size": "mini",
      "title": _vm.Reset
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeSelectedModuleConfig()
      }
    }
  }, [_vm._v("Reset\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-lg-1 no-padding"
  }, [_c('a', {
    staticClass: "btn-success",
    staticStyle: {
      "background": "#5cb85c",
      "position": "relative !important"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.saveAndPublishAxt()
      }
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-2"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Enable/Disable")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "line-height": "35px !important"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.axtConfig.isEnabled),
      callback: function($$v) {
        _vm.$set(_vm.axtConfig, "isEnabled", $$v)
      },
      expression: "axtConfig.isEnabled"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("\n                                    Ignore Ad-Unit Auto detection\n                                ")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "line-height": "35px !important"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.axtConfig.activateWhitelist),
      callback: function($$v) {
        _vm.$set(_vm.axtConfig, "activateWhitelist", $$v)
      },
      expression: "axtConfig.activateWhitelist"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 no-padding"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Initial exposure(sec)")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "initial"
    },
    model: {
      value: (_vm.axtConfig.initialExpo),
      callback: function($$v) {
        _vm.$set(_vm.axtConfig, "initialExpo", $$v)
      },
      expression: "axtConfig.initialExpo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Subsequent exposure(sec)")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "sub-sequent"
    },
    model: {
      value: (_vm.axtConfig.subSequentExpo),
      callback: function($$v) {
        _vm.$set(_vm.axtConfig, "subSequentExpo", $$v)
      },
      expression: "axtConfig.subSequentExpo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [
    [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.axtDCBlockList,
        "stripe": "",
        "height": "200"
      },
      on: {
        "selection-change": _vm.handleDCSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "width": "30"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "advertiser_id",
        "align": _vm.left,
        "label": "Advertiser/Campaign ID",
        "width": "600"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "IsBlocked",
        "width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [(props.row.is_blocklisted) ? _c('div', {
            staticClass: "text-center"
          }, [_c('svg', {
            staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
            attrs: {
              "data-v-7a40f996": "",
              "aria-hidden": "true",
              "height": "20px",
              "width": "20px",
              "data-prefix": "far",
              "data-icon": "check-circle",
              "role": "img",
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 512 512"
            }
          }, [_c('path', {
            attrs: {
              "data-v-7a40f996": "",
              "fill": "green",
              "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
            }
          })])]) : _vm._e(), _vm._v(" "), (!props.row.is_blocklisted) ? _c('div', {
            staticClass: "text-center"
          }, [_c('svg', {
            staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
            attrs: {
              "aria-hidden": "true",
              "height": "20px",
              "width": "20px",
              "data-prefix": "fal",
              "data-icon": "times-circle",
              "role": "img",
              "xmlns": "http://www.w3.org/2000/svg",
              "viewBox": "0 0 512 512"
            }
          }, [_c('path', {
            attrs: {
              "fill": "red",
              "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
            }
          })])]) : _vm._e()]
        }
      }])
    })], 1)]
  ], 2), _vm._v(" "), (!_vm.enableDCConfigSetting) ? _c('div', {
    staticClass: "col-lg-12 col-md-12",
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('div', {
    staticClass: "col-md-10 col-lg-10"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Advertiser/Campaign ID")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-top": "7px !important"
    },
    attrs: {
      "placeholder": "Advertiser/Campaign Id"
    },
    model: {
      value: (_vm.directCampConfig.advertId),
      callback: function($$v) {
        _vm.$set(_vm.directCampConfig, "advertId", $$v)
      },
      expression: "directCampConfig.advertId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary btn-mt",
    staticStyle: {
      "margin-top": "20px !important"
    },
    on: {
      "click": function($event) {
        return _vm.addAdvertiserIdtoBlock()
      }
    }
  }, [_vm._v("\n                                    Add\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-lg-1"
  }, [_c('button', {
    staticClass: "btn btn-md btn-danger btn-mt",
    staticStyle: {
      "margin-top": "20px !important"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSelectedDCId()
      }
    }
  }, [_vm._v("delete")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, _vm._l((_vm.axtConfig.associatedTags), function(dimension, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-6 col-md-6"
    }, [_c('div', {
      staticClass: "col-lg-3 col-md-3 no-padding",
      staticStyle: {
        "padding-top": "10px !important"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": dimension.creativeSizeLable,
        "size": "small"
      },
      model: {
        value: (dimension.isChecked),
        callback: function($$v) {
          _vm.$set(dimension, "isChecked", $$v)
        },
        expression: "dimension.isChecked"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-lg-8 col-md-8 no-padding",
      staticStyle: {
        "margin-top": "3px"
      }
    }, [_c('el-select', {
      attrs: {
        "size": "small",
        "placeholder": "Select Tag",
        "filterable": ""
      },
      model: {
        value: (_vm.axtConfig.associatedTags[index].selectedTags),
        callback: function($$v) {
          _vm.$set(_vm.axtConfig.associatedTags[index], "selectedTags", $$v)
        },
        expression: "axtConfig.associatedTags[index].selectedTags"
      }
    }, _vm._l((_vm.axtTags), function(tags) {
      return _c('el-option', {
        key: tags.id,
        attrs: {
          "label": tags['dfp-ad-unit-path'],
          "value": tags.id,
          "selected": dimension.selectedTags == tags.id
        }
      })
    }), 1)], 1)])
  }), 0)]), _vm._v(" "), _vm._m(3), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.axtConfigUnitList,
      "stripe": "",
      "height": "400"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "layoutName",
      "sortable": "",
      "filters": _vm.filterList,
      "filter-method": _vm.layoutFilterHandler,
      "label": "Layout",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adSpotName",
      "label": "Ad Spot",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Block AXT",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.isBlocked) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
          attrs: {
            "data-v-7a40f996": "",
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "far",
            "data-icon": "check-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "data-v-7a40f996": "",
            "fill": "green",
            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
          }
        })])]) : _vm._e(), _vm._v(" "), (!props.row.isBlocked) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
          attrs: {
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "fal",
            "data-icon": "times-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "red",
            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
          }
        })])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Force AXT",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.isWhitelisted) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
          attrs: {
            "data-v-7a40f996": "",
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "far",
            "data-icon": "check-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "data-v-7a40f996": "",
            "fill": "green",
            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
          }
        })])]) : _vm._e(), _vm._v(" "), (!props.row.isWhitelisted) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
          attrs: {
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "fal",
            "data-icon": "times-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "red",
            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
          }
        })])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Initial(sec)",
      "prop": "initialExpo",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Subsequent(sec)",
      "prop": "subSeqExpo",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Ignore Activity",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.ignoreActivity) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
          attrs: {
            "data-v-7a40f996": "",
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "far",
            "data-icon": "check-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "data-v-7a40f996": "",
            "fill": "green",
            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
          }
        })])]) : _vm._e(), _vm._v(" "), (!props.row.ignoreActivity) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
          attrs: {
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "fal",
            "data-icon": "times-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "red",
            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
          }
        })])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Selected Tag "
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('div', [_vm._v("\n                                        " + _vm._s(_vm.getTag(_vm.axtTags, prop.row.tagId)) + "\n                                    ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Multisize Dimension(WxH)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(prop) {
        return [_c('div', [_vm._v("\n                                        " + _vm._s(_vm.getDimensionLable(prop.row.multiSize)) + "\n                                    ")])]
      }
    }])
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [(_vm.multiSelectedUnits.length == 0) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 no-padding"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-5"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Layout")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select a Layout"
    },
    on: {
      "change": _vm.getAdSpots
    },
    model: {
      value: (_vm.setUnitConfig.layout),
      callback: function($$v) {
        _vm.$set(_vm.setUnitConfig, "layout", $$v)
      },
      expression: "setUnitConfig.layout"
    }
  }, _vm._l((_vm.layoutsList), function(layout) {
    return _c('el-option', {
      key: layout.id,
      attrs: {
        "label": layout.layout_name,
        "value": layout.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-5"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ad Spot")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select a AdSpot"
    },
    model: {
      value: (_vm.setUnitConfig.layoutAdSpots),
      callback: function($$v) {
        _vm.$set(_vm.setUnitConfig, "layoutAdSpots", $$v)
      },
      expression: "setUnitConfig.layoutAdSpots"
    }
  }, _vm._l((_vm.layoutAdSpotsList), function(adSpot) {
    return _c('el-option', {
      key: adSpot.id,
      attrs: {
        "label": adSpot.adSpot,
        "value": adSpot.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary btn-mt",
    on: {
      "click": function($event) {
        return _vm.addUnitToConfigList()
      }
    }
  }, [_vm._v("\n                                    Add\n                                ")])])]) : _vm._e(), _vm._v(" "), (_vm.multiSelectedUnits.length > 0) ? _c('div', {
    staticClass: "col-md-12 col-lg-12 no-padding"
  }, [_c('div', {
    staticClass: "col-md-1 col-lg-1"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Block AXT")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "line-height": "30px !important"
    },
    attrs: {
      "disabled": _vm.multiSelectConfig.isWhitelisted,
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.multiSelectConfig.isBlocked),
      callback: function($$v) {
        _vm.$set(_vm.multiSelectConfig, "isBlocked", $$v)
      },
      expression: "multiSelectConfig.isBlocked"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-lg-1"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Force AXT")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "line-height": "30px !important"
    },
    attrs: {
      "disabled": _vm.multiSelectConfig.isBlocked,
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.multiSelectConfig.isWhitelisted),
      callback: function($$v) {
        _vm.$set(_vm.multiSelectConfig, "isWhitelisted", $$v)
      },
      expression: "multiSelectConfig.isWhitelisted"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-lg-2"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Initial exposure(sec)")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.multiSelectConfig.isBlocked,
      "placeholder": "Initial"
    },
    model: {
      value: (_vm.multiSelectConfig.initialExpo),
      callback: function($$v) {
        _vm.$set(_vm.multiSelectConfig, "initialExpo", $$v)
      },
      expression: "multiSelectConfig.initialExpo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-lg-2"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Subsequent exposure(sec)")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": _vm.multiSelectConfig.isBlocked,
      "placeholder": "Subsequent"
    },
    model: {
      value: (_vm.multiSelectConfig.subSeqExpo),
      callback: function($$v) {
        _vm.$set(_vm.multiSelectConfig, "subSeqExpo", $$v)
      },
      expression: "multiSelectConfig.subSeqExpo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-lg-2"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Select Tag")]), _vm._v(" "), _c('el-select', {
    staticClass: "tag-dropdown",
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "Select Tag",
      "filterable": "",
      "disabled": _vm.multiSelectConfig.isBlocked
    },
    model: {
      value: (_vm.multiSelectConfig.tagId),
      callback: function($$v) {
        _vm.$set(_vm.multiSelectConfig, "tagId", $$v)
      },
      expression: "multiSelectConfig.tagId"
    }
  }, _vm._l((_vm.axtTags), function(tags) {
    return _c('el-option', {
      key: tags.id,
      attrs: {
        "label": tags['dfp-ad-unit-path'],
        "value": tags.id,
        "selected": _vm.multiSelectConfig.tagId == tags.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-lg-2"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Multisize (W X H)")]), _vm._v(" "), _c('el-select', {
    staticClass: "tag-dropdown",
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "W X H",
      "filterable": "",
      "disabled": _vm.multiSelectConfig.isBlocked
    },
    model: {
      value: (_vm.multiSelectConfig.multiSize),
      callback: function($$v) {
        _vm.$set(_vm.multiSelectConfig, "multiSize", $$v)
      },
      expression: "multiSelectConfig.multiSize"
    }
  }, _vm._l((_vm.creativeSizeList), function(dimension) {
    return _c('el-option', {
      key: dimension.id,
      attrs: {
        "label": dimension.width + 'x' + dimension.height,
        "value": dimension.id,
        "selected": _vm.multiSelectConfig.multiSize == dimension.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-lg-1"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Ignore Activity")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "line-height": "30px !important"
    },
    attrs: {
      "disabled": _vm.multiSelectConfig.isBlocked,
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.multiSelectConfig.ignoreActivity),
      callback: function($$v) {
        _vm.$set(_vm.multiSelectConfig, "ignoreActivity", $$v)
      },
      expression: "multiSelectConfig.ignoreActivity"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiSelectedUnits.length > 0) ? _c('div', {
    staticClass: "col-md-12 col-lg-12 no-padding"
  }, [_c('div', {
    staticClass: "col-md-1 col-lg-1 no-padding text-center"
  }, [_c('a', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background": "#5cb85c",
      "position": "relative !important",
      "margin-top": "10px !important"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitConfiguration()
      }
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-lg-1 no-padding text-center"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "position": "relative !important",
      "margin-top": "10px !important"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.deleteAdSpotFromConfig()
      }
    }
  }, [_vm._v("Delete")])]), _vm._v(" "), _vm._m(4)]) : _vm._e()])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12",
    staticStyle: {
      "background": "#d6d7d9",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-11 col-md-11"
  }, [_c('h2', {
    staticClass: "box-title"
  }, [_vm._v("Direct Campaign Blocklist(Advertiser/Campaign ID)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12",
    staticStyle: {
      "background": "#d6d7d9",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-11 col-md-11"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("Tag Association")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12",
    staticStyle: {
      "background": "#d6d7d9",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-11 col-md-11"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ad-Unit specific configuration")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1 col-lg-1 no-padding text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "position": "relative !important",
      "margin-top": "10px !important"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancel")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d54eb3f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/axt/AxtModule.vue
// module id = 702
// module chunks = 2